import type { BaseSchemas } from "api-types";
import React, { createContext } from "react";

import type { ConnectorPropertiesSchema } from "../schemas";

export interface SortedConnectorPropertySchemas {
  shoppingDataSources: ConnectorPropertiesSchema[];
  analyticsDataSources: ConnectorPropertiesSchema[];
  marketingDataSources: ConnectorPropertiesSchema[];
  accountingDataSources: ConnectorPropertiesSchema[];
}

export interface ConnectorTransformerContextProps {
  dataSources: SortedConnectorPropertySchemas;
  customerDomain: string;
  featureFlags: BaseSchemas.FeatureFlags;
  logErrorHandler?: any;
}

export const ConnectorTransformerContext = createContext<ConnectorTransformerContextProps>({
  dataSources: {
    shoppingDataSources: [],
    analyticsDataSources: [],
    marketingDataSources: [],
    accountingDataSources: [],
  },
  customerDomain: "",
  featureFlags: { shopifyPrivateApp: false },
});

export const useTransformerContext = (): ConnectorTransformerContextProps => {
  const c = React.useContext(ConnectorTransformerContext);
  if (c === undefined) {
    throw new Error("useTransformerContext must be inside a ConnectorTransformerProvider with a value");
  }
  return c;
};

export const ConnectorTransformerProvider = ({ dataSources, customerDomain, featureFlags, children }) => (
  <ConnectorTransformerContext.Provider value={{ dataSources, customerDomain, featureFlags }}>
    {children}
  </ConnectorTransformerContext.Provider>
);
